export const CUSTOMER_VISIBLE_AREAS = [
    'Print Packing Lists',
    'Print Invoices',
    'Print Order Acknowledgements'
]